import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientModeService } from '~core/services/client-mode.service';
import { ExternalUser, InternalUser } from '~modules/auth/types/user.types';
import { RouteUtilsService } from '~shared/services/route-utils.service';

import { AuthService } from '../../services/auth.service';

@Component({
	selector: 'app-user-info',
	templateUrl: './user-info.component.html',
})
export class UserInfoComponent implements OnInit {
	public isUserInfoOpen = false;
	public currentUser$: Observable<InternalUser | ExternalUser>;
	public isUserInfoClicked: boolean;
	public clientModeAvailable$: Observable<boolean>;

	constructor(
		public authService: AuthService,
		private readonly clientModeService: ClientModeService,
		private readonly routeUtilsService: RouteUtilsService
	) {}
	@HostListener('click')
	openMenu(): void {
		this.isUserInfoClicked = true;
	}

	@HostListener('document:click')
	clickOutsideMenu(): void {
		if (!this.isUserInfoClicked) {
			this.isUserInfoOpen = false;
		}

		this.isUserInfoClicked = false;
	}

	async ngOnInit(): Promise<void> {
		this.currentUser$ = this.authService.currentUser$;
		this.clientModeAvailable$ = this.clientModeService.available$;
	}

	/** The menu's side trips bring the user back to the page they opened them from. */
	public get redirectTo(): string | undefined {
		return this.routeUtilsService.sideTripRedirectTo();
	}

	removeUserInfo(): void {
		this.isUserInfoOpen = false;
	}

	public get clientModeEnabled(): boolean {
		return this.clientModeService.enabled;
	}

	toggleClientMode(): void {
		this.clientModeService.setEnabled(!this.clientModeEnabled);
	}

	toggleUserInfo(): void {
		this.isUserInfoOpen = !this.isUserInfoOpen;
	}

	public onLogOut(e: Event): void {
		e.preventDefault();

		this.isUserInfoOpen = false;
		this.authService.logout();
	}
}
